var _circle, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgDummyAvatar = function SvgDummyAvatar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6059_48858",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8027,
    cy: 12.5,
    r: 12,
    fill: "#C4C4C4",
    stroke: "#08AF54"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6059_48858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.302734,
    width: 24.9133,
    height: 24.9133,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9033 12.6001C15.2765 12.6001 17.1987 10.6779 17.1987 8.30467C17.1987 5.93147 15.2765 4.00928 12.9033 4.00928C10.5301 4.00928 8.6079 5.93147 8.6079 8.30467C8.6079 10.6779 10.5301 12.6001 12.9033 12.6001ZM12.9033 14.7478C10.0361 14.7478 4.3125 16.1867 4.3125 19.0432V21.1909H21.4941V19.0432C21.4941 16.1867 15.7705 14.7478 12.9033 14.7478Z",
    fill: "#25629D"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDummyAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dummy-avatar.3565ebeb.svg";
export { ForwardRef as ReactComponent };